import { useState, type FormEvent } from 'react';
import { ApiError, apiAction } from '../lib/api';

/**
 * Magic-link sign-in (mirrors moxo-funnel's dev/email path). Google SSO isn't
 * wired for Michelangelo, so email is the way in. In dev with no mail server
 * the backend returns a `devLink` we render directly.
 */
export default function Login() {
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [sent, setSent] = useState(false);
  const [devLink, setDevLink] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      const res = await apiAction<{ ok: true; devLink?: string }>('/api/auth/request', { email });
      setSent(true);
      if (res.devLink) setDevLink(res.devLink);
    } catch (err) {
      setError(
        err instanceof ApiError
          ? err.status === 403
            ? 'Only @moxo.com emails can sign in.'
            : err.message
          : 'Something went wrong.',
      );
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="login-shell">
      <div className="card shadow-soft login-card">
        <div className="login-logo" />
        <h1 className="font-display">Studio</h1>
        <p className="login-sub">Sign in with your @moxo.com email.</p>

        {!sent ? (
          <form onSubmit={onSubmit} className="login-form">
            <input
              className="input"
              type="email"
              autoFocus
              required
              placeholder="you@moxo.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              disabled={submitting}
            />
            <button className="btn btn-primary login-btn" type="submit" disabled={submitting || !email}>
              {submitting ? 'Sending…' : 'Send magic link'}
            </button>
            {error && <div className="login-error">{error}</div>}
          </form>
        ) : (
          <div className="login-form">
            <p>Check your inbox — the link expires in 15 minutes.</p>
            {devLink && (
              <>
                <p className="login-sub">Dev shortcut (no mail server configured):</p>
                <div className="login-devlink">
                  <a href={devLink}>{devLink}</a>
                </div>
              </>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
